export default function TriangleErrorIcon(props: React.SVGAttributes<{}>) {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99976 6.5V9.83333M9.99976 13.1667H10.0081M18.108 14.0002L11.4414 2.33352C11.296 2.07702 11.0852 1.86368 10.8305 1.71524C10.5757 1.56681 10.2862 1.48861 9.99136 1.48861C9.69654 1.48861 9.40699 1.56681 9.15226 1.71524C8.89753 1.86368 8.68673 2.07702 8.54136 2.33352L1.8747 14.0002C1.72777 14.2547 1.65072 14.5434 1.65137 14.8373C1.65202 15.1311 1.73035 15.4196 1.8784 15.6734C2.02646 15.9272 2.23899 16.1373 2.49444 16.2825C2.7499 16.4277 3.0392 16.5028 3.33303 16.5002H16.6664C16.9588 16.4999 17.246 16.4227 17.4991 16.2763C17.7522 16.1299 17.9624 15.9194 18.1085 15.6661C18.2545 15.4128 18.3314 15.1255 18.3313 14.8331C18.3312 14.5407 18.2542 14.2534 18.108 14.0002Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
